(() => {
  const root = document.querySelector('[data-bevanup-product]');
  const data = document.querySelector('[data-product-variants]');
  if (!root || !data) return;
  const variants = JSON.parse(data.textContent);
  const form = root.querySelector('[data-product-form]');
  const id = root.querySelector('[data-variant-id]');
  const price = root.querySelector('[data-product-price]');
  const label = root.querySelector('[data-add-label]');
  const priceLabel = root.querySelector('[data-add-price]');
  const colorValue = root.querySelector('[data-product-color-value]');
  const button = root.querySelector('[data-add-button]');
  const status = root.querySelector('[data-product-status]');
  const paymentToggle = root.querySelector('[data-payment-options-toggle]');
  const paymentDialog = root.querySelector('[data-payment-options-dialog]');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US',{style:'currency',currency:'USD'}).format(cents / 100);
  const sync = () => {
    const values = variants[0]?.options?.slice() || [];
    Array.from(root.querySelectorAll('[data-option-index]')).forEach(group => {
      values[Number(group.dataset.optionIndex)] = group.querySelector('input:checked')?.value;
    });
    const variant = variants.find(item => item.options.every((value,index) => value === values[index]));
    if (!variant) return;
    id.value = variant.id;
    const formatted = money(variant.price);
    price.textContent = formatted; priceLabel.textContent = formatted;
    const colorGroup = Array.from(root.querySelectorAll('[data-option-index]')).find(group => /^(color|colour|颜色)$/i.test(group.dataset.optionName || ''));
    const colorInput = colorGroup?.querySelector('input:checked');
    if (colorValue && colorInput) colorValue.textContent = colorInput.value;
    button.disabled = !variant.available; label.textContent = variant.available ? 'ADD TO BAG' : 'SOLD OUT';
  };
  root.addEventListener('change', event => { if (event.target.matches('[data-option-index] input')) sync(); });
  form?.addEventListener('submit', async event => {
    event.preventDefault(); if (button.disabled) return;
    button.disabled = true; status.textContent = 'ADDING TO BAG';
    try { const response = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:Number(id.value),quantity:1})}); if (!response.ok) throw new Error(); status.textContent = 'ADDED TO BAG'; sessionStorage.setItem('bevanup-open-cart-after-add','true'); window.location.reload(); }
    catch { status.textContent = 'UNABLE TO ADD — PLEASE TRY AGAIN'; }
    finally { window.setTimeout(() => { button.disabled = false; status.textContent = ''; sync(); },1500); }
  });
  root.querySelectorAll('[data-related-panel]').forEach(panel => {
    const cards = Array.from(panel.querySelectorAll('[data-related-candidate]'));
    for (let index = cards.length - 1; index > 0; index -= 1) {
      const pick = Math.floor(Math.random() * (index + 1));
      [cards[index], cards[pick]] = [cards[pick], cards[index]];
    }
    cards.forEach((card, index) => { card.hidden = index >= 4; });
    cards.slice(0, 4).forEach(card => panel.append(card));
  });
  root.querySelectorAll('[data-related-tab]').forEach(tab => tab.addEventListener('click', () => {
    const target = tab.dataset.relatedTab;
    root.querySelectorAll('[data-related-tab]').forEach(item => { const selected = item === tab; item.classList.toggle('is-active', selected); item.setAttribute('aria-selected', String(selected)); });
    root.querySelectorAll('[data-related-panel]').forEach(panel => { panel.hidden = panel.dataset.relatedPanel !== target; });
  }));
  root.querySelectorAll('[data-related-image]').forEach(image => image.addEventListener('pointerdown', event => {
    if (event.pointerType === 'mouse') return;
    const card = image.closest('.bevanup-product__related-card');
    if (!card?.querySelector('.bevanup-product__related-alternate') || card.classList.contains('is-image-alternate')) return;
    event.preventDefault(); card.classList.add('is-image-alternate');
  }));
  paymentToggle?.addEventListener('click', () => { paymentDialog.hidden = false; root.querySelector('[data-payment-options-close]')?.focus(); });
  root.querySelector('[data-payment-options-close]')?.addEventListener('click', () => { paymentDialog.hidden = true; paymentToggle.focus(); });
  paymentDialog?.addEventListener('click', event => { if (event.target === paymentDialog) { paymentDialog.hidden = true; paymentToggle.focus(); } });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && !paymentDialog?.hidden) { paymentDialog.hidden = true; paymentToggle?.focus(); } });
  if (sessionStorage.getItem('bevanup-open-cart-after-add') === 'true') {
    sessionStorage.removeItem('bevanup-open-cart-after-add');
    customElements.whenDefined('theme-drawer').then(() => document.querySelector('#cart-drawer')?.open?.());
  }
  sync();
})();